import React, { useState, useContext } from "react"
import Accordian from "./MobileAccordian"
import EmptyScreenLayout from "../EmptyScreenLayout"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { MyContext } from "../../../pages/Reports/VerifyMyTeams/index"

const MobileTable = props => {
  const { pathname } = useLocation()

  const { data, handleOnExpand, handleVerify } = props
  // State to keep track of selected rows in the table
  const { dataTeam, selectToggleTeam, onClickSubmitButton } =
    useContext(MyContext) || {}

  const [handleAccordion, sethandleAccordion] = useState(false)
  const renderDatalist =
    data?.length === 1 ? data?.map(el => el?.projectTimeSheet)?.[0] : data

  return (
    <>
      {pathname === "/verifyscreen" ? (
        <>
          {renderDatalist?.length === 0 ? (
            <EmptyScreenLayout
              content={"Sorry, There are no data to display"}
            />
          ) : (
            <>
              {renderDatalist?.map((items, index) => (
                <div key={index}>
                  <Accordian
                    handleAccordion={handleAccordion}
                    sethandleAccordion={sethandleAccordion}
                    keyId={index}
                    itemProject={items?.displayName}
                    item={renderDatalist}
                    handleOnExpand={handleOnExpand}
                    handleVerify={handleVerify}
                  />
                </div>
              ))}
            </>
          )}
        </>
      ) : (
        <>
          {dataTeam?.length === 0 ? (
            <EmptyScreenLayout
              content={"Sorry, There are no data to display"}
            />
          ) : (
            dataTeam?.map((items, index) => (
              <div key={index}>
                <Accordian
                  handleAccordion={handleAccordion}
                  sethandleAccordion={sethandleAccordion}
                  keyId={index}
                  itemProject={
                    !selectToggleTeam ? items?.project : items?.displayName
                  }
                  item={dataTeam || []}
                  onClickSubmitButton={onClickSubmitButton}
                />
              </div>
            ))
          )}
        </>
      )}
    </>
  )
}

export default MobileTable
